import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getChallenges } from "../../../features/slices/challanges";
import CommonPagination from "../../CommonPagination";
import { useSelector } from "react-redux";
import TableSkeleton from "../../TableSkeleton";
import ExportToExcel from "../../ExportToExcel";
import moment from "moment";
import { Link } from "react-router-dom";
const initialState = {
  fromDate: "",
  toDate: "",
  timeframe: "",
  searchQuery: "",
  category: "",
};
const Ongoing = () => {
  const [iState, setUpdateState] = useState(initialState);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const ongoingRef = useRef();
  const { searchQuery, fromDate, toDate, timeframe, category } = iState;
  const { challenges, loading } = useSelector((state) => {
    return state.challenges;
  });
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      type: "Ongoing",
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }

    dispatch(getChallenges(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = {
      timeframe: e.target.value,
      type: "Ongoing",
    };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getChallenges(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getChallenges({ page, type: "Ongoing" }));
  };
  useEffect(() => {
    dispatch(getChallenges({ type: "Ongoing" }));
  }, [page]);
  useEffect(() => {
    if (searchQuery?.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getChallenges({ searchQuery: searchQuery, type: "Ongoing" })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCategory = (e) => {
    setUpdateState((prev) => ({
      ...prev,
      category: e.target.value,
    }));
    dispatch(getChallenges({ categoryId: e.target.value, type: "Ongoing" }));
  };
  return (
    <>
      {challenges?.result?.[0]?.paginationData?.length > 0 ? (
        <div className="tab-pane fade active show" id="Ongoing">
          <div className="FilterArea">
            <div className="FilterLeft">
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  disabled={timeframe}
                  name="fromDate"
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={toDate}
                  disabled={timeframe}
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button className="Button" onClick={handleSubmit}>
                  Apply
                </button>
              </div>
              <div className="form-group">
                <label>Timeframe</label>
                <select
                  className="form-control customSelect"
                  name="timeframe"
                  value={timeframe}
                  disabled={fromDate || toDate}
                  onChange={(e) => handleTimeFrame(e)}
                >
                  <option value="" hidden>
                    Select
                  </option>
                  <option value="Today">Today</option>
                  <option value="Week">This Week</option>
                  <option value="Month">This Month</option>
                </select>
              </div>
            </div>
          </div>
          <div className="NewFilter">
            <div className="SearchBox">
              <input
                type="search"
                className="SearchInput"
                placeholder="Search here by ID, title, or Others"
                name="searchQuery"
                value={searchQuery}
                onChange={(e) => handleSearch(e)}
              />
              <span>
                <i className="fa fa-search" />
              </span>
            </div>
            <div className="Actions">
              <div
                className="form-group"
                style={{
                  textAlign: "center",
                }}
              >
                {/* <button className="FilterBtn">
                  <span>
                    <img src={require("../../../assets/images/filter.png")} />
                  </span>
                  Filters */}
                <select
                  className="form-control FilterStatus"
                  name="category"
                  value={category}
                  onChange={(e) => handleChangeCategory(e)}
                >
                  <option value="" hidden>
                    Filter by category
                  </option>
                  {challenges?.result?.[0]?.paginationData?.map((res, i) => {
                    return (
                      <option value={res?.categoryId} key={i}>
                        {res?.categoryData?.[0]?.categoryName}
                      </option>
                    );
                  })}
                </select>
                {/* </button> */}
              </div>
              <button className="Button Cancel" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
              <ExportToExcel
                ref={ongoingRef}
                fileName="ongoingChallangesData"
              />
            </div>
          </div>
          <div className="TableList">
            <table className="table-hover" ref={ongoingRef}>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Challenge Id</th>
                  <th>Challenge Title</th>
                  <th>Category</th>
                  <th>Start Date</th>
                  <th>Deadline Date</th>
                  <th>No. of Submissions</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <TableSkeleton />
                ) : (
                  challenges?.result?.[0]?.paginationData?.map((res, i) => {
                    return (
                      <tr key={res?._id}>
                        <td>{i + 1 + (page - 1) * 10}</td>
                        <td>{res?.challenge_number}</td>
                        <td>{res?.title}</td>

                        <td>{res?.categoryData?.[0]?.categoryName}</td>
                        <td>{moment(res?.startDate).format("YYYY/MM/DD")}</td>
                        <td>{moment(res?.endDate).format("YYYY/MM/DD")}</td>
                        <td>
                          <Link
                            to="liveSubmissionCompleted/ongoing"
                            className="LinkDirect ml-0"
                            state={res?._id}
                          >
                            {res?.attendCount}
                          </Link>
                        </td>
                        <td>
                          <div className="Actions">
                            <Link
                              to="challengesDetails"
                              className="Eyes"
                              state={res}
                            >
                              <i className="fa-regular fa-eye" />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {challenges?.result?.[0]?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {challenges?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {challenges?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    challenges?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "white",
            height: "200px",
            color: "green",
          }}
        >
          No ongoing challange Yet! Please add a new challange
        </p>
      )}
    </>
  );
};

export default Ongoing;
